import { readUnhandledEnumCase } from 'rpc-client-utils';
import getLang from '../utils/getLang';
export const ACADEMY_SUPPORTED_LANGUAGES = ['EN', 'ES', 'DE', 'JA', 'FR', 'PT'];
function toLowerCaseTuple(arr) {
  return arr.map(language => language.toLowerCase());
}
export const supportedPublicLanguages = toLowerCaseTuple(ACADEMY_SUPPORTED_LANGUAGES);
export const convertToSupportedLanguage = lang => {
  var _lang$toUpperCase;
  const upperLang = (_lang$toUpperCase = lang === null || lang === void 0 ? void 0 : lang.toUpperCase()) !== null && _lang$toUpperCase !== void 0 ? _lang$toUpperCase : 'EN';
  return ACADEMY_SUPPORTED_LANGUAGES.includes(upperLang) ? upperLang : 'EN';
};
export const getSupportedLanguage = () => {
  return convertToSupportedLanguage(getLang());
};
export const convertToLegacyLanguage = language => {
  return readUnhandledEnumCase(language).toLowerCase();
};